<!--  -->
<template>
  <div class="time_pushbox" style="padding: 30px">
    <div class="strate_box">
      <div>策略名称：</div>
      <el-input v-model="pushtimevalue" style="width:200px" placeholder="请输入群发标题" />
    </div>
    <div class="strate_box">
      <div>策略平台：</div>
      <el-select v-model="promlateidStr" placeholder="请选择" :disabled="ontype===0" @change="strategyplatform">
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <div class="title_boxtips">
        *涉及到AB号跳转，请选择通用平台
      </div>
    </div>
    <div v-if="promlateidStr!=null" class="strate_box">
      <div>选标签组：</div>
      <el-select v-model="labelgroupid" multiple :disabled="optionsr.length===0" placeholder="请选择" @visible-change="labelGroupChange">
        <el-option
          v-for="item in optionsr"
          :key="item.id"
          :label="item.tag_group_name"
          :value="item.id"
        />
      </el-select>
      <div v-if="promlateidStr!=null" class="title_boxtips">
        *多标签组合为并且的关系
      </div>
    </div>
    <div class="strate_box">
      <div>关注时间：</div>
      <div>
        <el-select v-model="subscribe_time_type" placeholder="请选择">
          <el-option
            v-for="item in optionsrr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div v-if="subscribe_time_type === 7" style="margin-left:10px">
        <el-date-picker
          v-model="subscribetime"
          style="width:400px"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm"
          :default-time="['00:00:00', '23:59:59']"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="false"
          @change="timechanger"
        />
      </div>
    </div>
    <div class="strate_box">
      <div>互动时间：</div>
      <div>
        <el-select v-model="interaction_time_type" placeholder="请选择">
          <el-option
            v-for="item in optionsrr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div v-if="interaction_time_type === 7" style="margin-left:10px">
        <el-date-picker
          v-model="interactiontime"
          style="width:400px"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm"
          :default-time="['00:00:00', '23:59:59']"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="false"
          @change="timechangerall"
        />
      </div>
    </div>
    <div class="strate_box">
      <div>付费情况：</div>
      <div>
        <el-radio-group v-model="consumption">
          <el-radio :label="0">全部</el-radio>
          <el-radio :label="1">未付费</el-radio>
          <el-radio :label="2">已付费</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="strate_box">
      <div>添加好友时间：</div>
      <el-radio-group v-model="send_sort">
        <el-radio :label="1">倒序</el-radio>
        <el-radio :label="2">正序</el-radio>
      </el-radio-group>
    </div>
    <div class="strate_box">
      <div class="title_box">
        每日发送时间：
      </div>
      <div class="taewr">
        <div class="taewr" style="margin-left:10px;width:120px">
          <!-- <el-input v-model="item.hourvalue" type="number" style="width:80px" @blur="tinebulie(index)" />
              <div class="tiwmebox">时</div> -->
          <el-select v-model="houroptionsr" placeholder="请选择" style="width:90px;margin-left:10px">
            <el-option v-for="index in 23" :key="index" :label="index" :value="index" />
          </el-select>
          <div class="tiwmebox">时</div>
        </div>
        <br>
        <br>
        <div class="taewr" style="margin-left:30px;width:120px">
          <!-- <el-input v-model="item.minutevalue" type="number" style="width:80px" @blur="tiwrrw(index)" /> -->
          <el-select v-model="minutevalue" placeholder="请选择" style="width:90px;margin-left:10px">
            <el-option v-for="index in 59" :key="index" :label="index" :value="index" />
          </el-select>
          <div class="tiwmebox">分</div>
        </div>
      </div>
    </div>
    <div v-if="ontype === 0" class="strate_box">
      <div>延续上次发送：</div>
      <el-radio-group v-model="continue_last">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="2">否</el-radio>
      </el-radio-group>
    </div>
    <div class="strate_box">
      <div>循环推送：</div>
      <el-radio-group v-model="loop_push">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="2">否</el-radio>
      </el-radio-group>
    </div>
    <div v-if="promlateidStr!=null" class="strate_box">
      <div>
        选择的消息：
      </div>
      <div>
        {{ messagename }}
      </div>
    </div>
    <div class="search_box" style="margin-bottom:10px;">
      <el-select v-if="promlateidStr!=null" v-model="pageIfon.onlyMe" placeholder="请选择">
        <el-option
          v-for="item in accountarr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-input v-if="promlateidStr" v-model="pageIfon.title" style="width:200px;" placeholder="请输入标题" />
      <el-button v-if="promlateidStr" type="primary" icon="el-icon-search" @click="srarch">搜索</el-button>
    </div>
    <el-table
      v-if="promlateidStr!=null"
      ref="table"
      :key="refreshKey"
      :data="publicAdvelist"
      style="width: 100%"
    >
      <el-table-column
        label="选项"
        width="100"
      >
        <template slot-scope="scope">
          <el-radio-group v-model="articles_template_id">
            <el-radio :label="scope.row.id">{{ scope.row.$index }}</el-radio>
          </el-radio-group>
        </template>
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        align="center"
      />
      <el-table-column
        prop="platform_name"
        label="平台"
        align="center"
      />
      <el-table-column
        prop="real_name"
        label="创建人"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
      />
    </el-table>
    <pagination-right
      v-if="promlateidStr!=null"
      :total="total"
      :current-page="pageIfon.page"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <div>
      <el-button type="primary" size="small" @click="gobackone">返回</el-button>
      <el-button type="primary" size="small" @click="btnclick">{{ ontype === 0? '提交修改': '提交新增' }}</el-button>
    </div>
  </div>
</template>

<script>
import {
  strategyPlatform,
  accountlist,
  createStrategyPreview, strategyPreviewInfo, updateStrategyPreview, adminlist
} from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import convertToHump from '@/utils/mixins/convertToHump'
export default {
  components: {
    PaginationRight
  },
  mixins: [convertToHump],
  data() {
    return {
      interaction_time_type: 0, // 互动时间单位
      interactiontime: [], // 互动时间值
      interaction_time_from: '', // 互动时间 开始
      interaction_time_to: '', // 互动时间结束
      subscribetime: [],
      subscribe_time_from: '',
      subscribe_time_to: '',
      subscribe_time_type: 0,
      consumption: 0, // 付费情况
      articles_template_id: null, // 文章id
      optionsrr: [{
        value: 0,
        label: '不限'
      }, {
        value: 8,
        label: '24小时内'
      }, {
        value: 1,
        label: '2天(48小时)以内'
      }, {
        value: 2,
        label: '2天(48小时)前'
      }, {
        value: 3,
        label: '2至7天'
      }, {
        value: 4,
        label: '7天内'
      }, {
        value: 5,
        label: '7天前'
      }, {
        value: 6,
        label: '今天前'
      },
      {
        value: 7,
        label: '自定义'
      }],
      pushtimevalue: '', // 群发标题
      options: [], // 平台数组
      promlateidStr: null, // 策略平台名称
      promlate_id: null, // 策略平台id
      sendtime: null, // 发送时间
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      arrs: [], // 选择公众号数组
      arrsw: [], // 选择公众号数组 id集合
      dialogVisible: false,
      dialogVisibleser: false,
      messagename: '', // 文章名称
      messageid: null, // 消息id
      publicAdvelist: [], // 文章的列表数组
      refreshKey: 0, // 客服消息key
      total: null, // 总页数
      pageIfon: {
        page: 1,
        pageSize: 10,
        platform_id: 0,
        onlyMe: 2,
        title: ''
      },
      optionsr: [], // 所有标签组数据
      labelgroupid: [], // 已经选中的标签组的name
      wechatnumber: '', // 预览微信号
      radio: 0,
      input: '',
      num: null, // 天数传值
      lookdialogVisibleser: false,
      appid: null,
      app_name: '',
      savehistoryid: null,
      savehistory: [
        {
          id: 1,
          name: '保留'
        },
        {
          id: 2,
          name: '不保留'
        }
      ],
      previewdisbled: false,
      AandBdialogVisible: false,
      erroraccount: false,
      failsarr: [],
      allarr: [],
      historyarr: [],
      to_all: 1,
      accountarr: [{
        value: 1,
        label: '查看组内消息'
      }, {
        value: 2,
        label: '我关联的消息'
      }],
      policyobj: {
        page: 1,
        pageSize: 10,
        platform_id: null,
        strategy_type: null,
        strategy_no: null,
        strategy_name: null,
        onlyMe: 2
      },
      send_sort: 1,
      minutevalue: 0,
      houroptionsr: 0,
      ontype: 1,
      strategy_preview_no: null,
      continue_last: null,
      loop_push: 2
    }
  },

  created() {
    if (JSON.stringify(this.$route.query) !== '{}') {
      this.strategy_preview_no = this.$route.query.item
      // 默认新增，如果传入type则改动
      if (this.$route.query.type === 0) {
        this.ontype = 0
      } else {
        this.ontype = 1
      }
      this.platform_id = this.$route.query.platform_id
      // 查询strategy_preview_no 相关信息，同时赋值给对应数据 在此之前先通过平台id查询标签组内容
      this.strategyplatform(this.platform_id)
      strategyPreviewInfo({ strategy_preview_no: this.strategy_preview_no }).then((res) => {
        this.promlateidStr = res.data.platform_id
        this.pushtimevalue = res.data.strategy_name
        this.consumption = res.data.user_wheres === null ? 0 : res.data.user_wheres.consumption
        this.houroptionsr = res.data.hour
        this.minutevalue = res.data.minute
        this.send_sort = res.data.send_sort
        this.articles_template_id = res.data.articles_template_id
        this.messagename = res.data.articles_detail.title
        this.continue_last = res.data.continue_last === null ? 2 : res.data.continue_last
        this.loop_push = res.data.loop_push === null ? 2 : res.data.loop_push
        this.getliser()
        if (res.data.user_wheres === null) {
          this.subscribe_time_type = 0
          this.interaction_time_type = 0
        }
        if (res.data.user_wheres.interaction_time) {
          this.interaction_time_type = res.data.user_wheres.interaction_time.type
          if (res.data.user_wheres.interaction_time.type === 7) {
            if (res.data.user_wheres.interaction_time.interaction_time_range.length !== 0) {
              this.interactiontime = res.data.user_wheres.interaction_time.interaction_time_range
              this.interaction_time_from = this.interactiontime[0]
              this.interaction_time_to = this.interactiontime[1].value
            }
          }
        }
        if (res.data.user_wheres.subscribe_time) {
          this.subscribe_time_type = res.data.user_wheres.subscribe_time.type
          if (res.data.user_wheres.subscribe_time.type === 7) {
            if (res.data.user_wheres.subscribe_time.subscribe_time_range.length !== 0) {
              this.subscribetime = res.data.user_wheres.subscribe_time.subscribe_time_range
              this.subscribe_time_from = this.subscribetime[0]
              this.subscribe_time_to = this.subscribetime[1]
            }
          }
        }
        if (res.data.tag_group_ids.length === 0) {
          this.delayedarr = []
          this.labelgroupid = [0]
        } else {
          setTimeout(() => { // 加定时器稍微延时一下就可解决问题
            res.data.tag_group_ids.forEach(id => {
              const find = this.optionsr.find(item => item.id === id)
              // const find = this.optionsr.find(function(item) {
              //   console.log('item', item.id, id)
              //   if (item.id == id) {
              //     return item
              //   }
              // })
              this.labelgroupid.push(find.tag_group_name)
            })
          }, 1000)
        }
      })
    } else {
      // 新增
      this.ontype = 1
    }
    this.getstrategyplatformlist()
    this.optionsr.push({
      id: 0,
      tag_group_name: '全部'
    })
  },
  mounted() {
    if (Array.isArray(this.$refs.radio)) {
      this.$refs.radio.forEach((radioElement) => {
        radioElement.removeAttribute('aria-hidden')
      })
    }
  },
  methods: {
    timechanger(val) {
      this.subscribe_time_from = val[0]
      this.subscribe_time_to = val[1]
    },
    timechangerall(val) {
      this.interaction_time_from = val[0]
      this.interaction_time_to = val[1]
    },
    // 获取列表
    async getliser() {
      this.pageIfon.platform_id = this.promlate_id
      const data = await accountlist(this.pageIfon)
      this.publicAdvelist = data.data.list
      this.total = data.data.total
    },
    // 获取策略平台
    async getstrategyplatformlist() {
      const data = await strategyPlatform()
      this.options = data.data.list
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.getliser()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.getliser()
    },
    srarch() {
      this.pageIfon.page = 1
      this.getliser()
    },
    // 提交
    btnclick() {
      if (this.pushtimevalue === '') {
        this.$message.error('请输入策略名称')
        return
      }
      if (this.promlateidStr === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.subscribe_time_type === null) {
        this.$message.error('请选择关注时间')
        return
      }
      if (this.send_sort === 0) {
        this.$message.error('请选择添加好友时间')
        return
      }
      if (this.houroptionsr === this.minutevalue === 0) {
        this.$message.error('请选择每日发送时间')
        return
      }
      if (this.continue_last === null && this.ontype === 0) {
        this.$message.error('请选择是否继续上次发送')
        return
      }
      if (this.loop_push === null) {
        this.$message.error('请选择是否循环推送')
        return
      }
      if (this.ontype === 1) {
        const create_data = {
          strategy_name: this.pushtimevalue,
          platform_id: this.promlateidStr,
          articles_template_id: this.articles_template_id,
          tag_group_ids: this.labelgroupid,
          send_sort: this.send_sort,
          consumption: this.consumption,
          subscribe_time_type: this.subscribe_time_type,
          subscribe_time_from: this.subscribe_time_type === 7 ? this.subscribetime[0] : null,
          subscribe_time_to: this.subscribe_time_type === 7 ? this.subscribetime[1] : null,
          interaction_time_type: this.interaction_time_type,
          interaction_time_from: this.interaction_time_type === 7 ? this.interactiontime[0] : null,
          interaction_time_to: this.interaction_time_type === 7 ? this.interactiontime[1] : null,
          hour: this.houroptionsr,
          minute: this.minutevalue,
          loop_push: this.loop_push
        }
        createStrategyPreview(create_data).then(res => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: `新增成功`
            })
            this.$router.go(-1)
          } else {
            this.$message({
              type: 'error',
              message: `${res.message}`
            })
          }
        })
      }
      if (this.ontype === 0) {
        const update_data = {
          strategy_preview_no: this.strategy_preview_no,
          strategy_name: this.pushtimevalue,
          platform_id: this.promlateidStr,
          tag_group_ids: this.labelgroupid[0] === 0 ? [] : this.labelgroupid,
          consumption: this.consumption,
          subscribe_time_type: this.subscribe_time_type,
          subscribe_time_from: this.subscribe_time_type === 7 ? this.subscribetime[0] : null,
          subscribe_time_to: this.subscribe_time_type === 7 ? this.subscribetime[1] : null,
          interaction_time_from: this.interaction_time_type === 7 ? this.interactiontime[0] : null,
          interaction_time_to: this.interaction_time_type === 7 ? this.interactiontime[1] : null,
          interaction_time_type: this.interaction_time_type,
          hour: this.houroptionsr,
          minute: this.minutevalue,
          send_sort: this.send_sort,
          articles_template_id: this.articles_template_id,
          continue_last: this.continue_last,
          loop_push: this.loop_push
        }
        updateStrategyPreview(update_data).then(res => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: `修改成功！！`
            })
            this.$router.go(-1)
          } else {
            this.$message({
              type: 'error',
              message: `${'修改失败，请联系管理员'}`
            })
          }
        })
      }
      // eslint-disable-next-line no-empty
      this.arrsw = this.arrs.map(item => {
        return item.id
      })
    },
    // 返回
    gobackone() {
      this.$router.go(-1)
    },
    async strategyplatform(val) {
      this.promlate_id = val
      // 每次变化平台id 需要改变对应的标签组内容，如果是修改，则会根据strategy_preview_no改变标签组内容和选定情况
      // val是平台id labelgroupid是选中的标签，optionsr是全部标签
      const data = await adminlist({
        page: 1,
        page_size: 50,
        platform_id: val
      })
      this.optionsr = data.data.list
      this.optionsr.unshift({
        id: 0,
        tag_group_name: '全部'
      })
      this.getliser()
    },
    labelGroupChange() {
      for (let i = 0; i < this.labelgroupid.length; i++) {
        if (this.labelgroupid[i] === 0) {
          this.labelgroupid = [0]
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
/* @import url(); 引入css类 */
.time_pushbox{
  padding: 20px;
}
.tiwmebox{
  width: 50px;
  background: #f4f7f7;
  height: 36px;
  border: 1px solid #cccccc;
  border-left: 0px;
  text-align: center;
  line-height: 36px;
  color: #61686b;
  border-radius: 0px 5px 5px 0px;
}
.taewr{
  display: flex;
  align-items: center;
}
.strate_box{
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  div{
    flex-shrink: 0;
    font-size: 14px;
    color: #606266;
  }
  span{
    margin-left: 10px;
  }
}
.title_boxtips{
  color: #F56C6C !important;
  margin-left: 10px;
}
.tag_box{
  margin-right: 10px;
  cursor: pointer;
}
</style>
